import { TokenService } from './token.service';
import { AuthService } from './auth.service';
import type { Logger } from '../logging';

export class LoginManager {
  public readonly tokenService: TokenService;
  public readonly authService: AuthService;

  constructor(logger: Logger) {
    const tokenService = new TokenService(logger);
    this.tokenService = tokenService;
    this.authService = new AuthService(tokenService);
  }

  // ====================================================
  // Token Service
  // ====================================================

  public accessTokenObservable: TokenService['accessTokenObservable'] = () => {
    return this.tokenService.accessTokenObservable();
  };

  public authenticate: TokenService['authenticate'] = () => {
    return this.tokenService.authenticate();
  };

  public getToken: TokenService['getToken'] = () => {
    return this.tokenService.getToken();
  };

  public getTokenAsync: TokenService['getTokenAsync'] = () => {
    return this.tokenService.getTokenAsync();
  };

  public setToken: TokenService['setToken'] = (token, clientId, refreshToken, serverTime) => {
    return this.tokenService.setToken(token, clientId, refreshToken, serverTime);
  };

  public hasValidMfaClaim: TokenService['hasValidMfaClaim'] = () => {
    return this.tokenService.hasValidMfaClaim();
  };

  // ====================================================
  // Auth Service
  // ====================================================

  public changePassword: AuthService['changePassword'] = email => {
    return this.authService.changePassword(email);
  };

  public loginWithFacebook: AuthService['loginWithFacebook'] = (redirectUri, redirectUriOnFail) => {
    return this.authService.loginWithFacebook(redirectUri, redirectUriOnFail);
  };

  public loginWithGoogle: AuthService['loginWithGoogle'] = (redirectUri, redirectUriOnFail) => {
    this.authService.loginWithGoogle(redirectUri, redirectUriOnFail);
  };

  public loginWithUsernameAndPassword: AuthService['loginWithUsernameAndPassword'] = (email, password, redirectUri, redirectUriOnFail) => {
    return this.authService.loginWithUsernameAndPassword(email, password, redirectUri, redirectUriOnFail);
  };

  public isAdminOrOwner: AuthService['isAdminOrOwner'] = aclString => {
    return this.authService.isAdminOrOwner(aclString);
  };

  public signupWithUsernameAndPassword: AuthService['signupWithUsernameAndPassword'] = (email, password, redirectUri, redirectUriOnFail) => {
    return this.authService.signupWithUsernameAndPassword(email, password, redirectUri, redirectUriOnFail);
  };
}
